// Shared defaults for the profile question editor. Keep DEFAULT_DESCRIPTION_LABEL in
// sync with ProjectController::DEFAULT_DESCRIPTION_LABEL.
export const DEFAULT_DESCRIPTION_LABEL = "Please elaborate in 1-2 sentences on your work experience.";

export const DEFAULT_QUESTION = "Can you discuss XXXXX? Please elaborate in 1-2 sentences on your work experience.";
